<template>
  <div class="order-third" v-loading.fullscreen.lock="complianceChecking">
    <div class="crumbs-navigation">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/main' }">{{ $t('createQuotation.myQuotation') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('createQuotation.discountInformation') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="flow-chart">
      <div class="el-steps el-steps--horizontal" style="justify-content: center;">
        <div class="el-step is-horizontal is-center" style="flex-basis: 15%; margin-right: 0px;">
          <div class="el-step__head is-finish">
            <div class="el-step__line" style="margin-right: 0px;">
              <i class="el-step__line-inner"
                 style="transition-delay: 0ms; border-width: 0px; width: 0%;"
              />
            </div>
            <div class="el-step__icon is-icon" @click="jump1Step(projectId,projectName)"><i class="el-step__icon-inner step1selected" /></div>
          </div>
          <div class="el-step__main">
            <div class="el-step__title is-finish">{{ $t('createQuotation.projectBasicInformation') }}</div>
            <div class="el-step__description is-finish" />
          </div>
        </div>
        <div class="el-step is-horizontal is-center" style="flex-basis: 15%; margin-right: 0px;">
          <div class="el-step__head is-finish">
            <div class="el-step__line" style="margin-right: 0px;">
              <i class="el-step__line-inner"
                 style="transition-delay: -150ms; border-width: 0px; width: 0%;"
              />
            </div>
            <div class="el-step__icon is-icon" @click="jump2Step(projectId,projectName)"><i class="el-step__icon-inner step2selected" /></div>
          </div>
          <div class="el-step__main">
            <div class="el-step__title is-finish">{{ $t('createQuotation.productConfigurationList') }}</div>
            <div class="el-step__description is-finish" />
          </div>
        </div>
        <div class="el-step is-horizontal is-center" style="flex-basis: 15%; margin-right: 0px;">
          <div class="el-step__head is-finish">
            <div class="el-step__line" style="margin-right: 0px;">
              <i class="el-step__line-inner"
                 style="transition-delay: -300ms; border-width: 0px; width: 0%;"
              />
            </div>
            <div class="el-step__icon is-icon"><i class="el-step__icon-inner step3selected" /><!----></div>
          </div>
          <div class="el-step__main">
            <div class="el-step__title is-finish">{{ $t('createQuotation.discountInformation') }}</div>
            <div class="el-step__description is-finish" />
          </div>
        </div>
        <div class="el-step is-horizontal is-center" style="flex-basis: 15%; max-width: 25%;">
          <div class="el-step__head is-wait">
            <div class="el-step__line"><i class="el-step__line-inner" /></div>
            <div class="el-step__icon is-icon" @click="jump4Step(projectId,projectName)"><i class="el-step__icon-inner step4unselect" /></div>
          </div>
          <div class="el-step__main">
            <div class="el-step__title is-wait">{{ $t('createQuotation.exportShare') }}</div>
            <div class="el-step__description is-wait" />
          </div>
        </div>
      </div>
    </div>
    <div class="select-option">
      <el-row>
        <el-col :span="24">
          <div class="grid-content ">
            <a>
              {{ $t('createQuotation.theNameList') }}
              {{ projectName }}
            </a>
          </div>
          <div class="grid-content ">
            <a>
              {{ $t('createQuotation.catalogPrice') }}
              <span class="f-blue">
                {{ productPriceFormat(null,null,orderPrice) }}
              </span>
            </a>
          </div>
          <div class="grid-content ">
            <a>
              <!--折后总价-->
              {{ $t('createQuotation.totalPriceAfterDiscount') }}
              <span class="f-blue">
                {{ productPriceFormat(null,null,orderDiscountPrice) }}
              </span>
            </a>
          </div>
          <div class="grid-content ">
            <a>
              <!--整单折扣：-->
              {{ $t('createQuotation.wholeSingleDiscount') }}
              <span class="f-blue">
                {{ totalDiscountShow | number }}%
              </span>
            </a>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="clear" />
    <div class="discount">
      <el-row>
        <el-col :span="24">
          <div class="grid-content ">
            <a style="display: inline-block;">
              <!--设置折扣值（%）：-->
              {{ $t('createQuotation.setDiscountValue') }}
            </a>
          </div>
          <div class="grid-content ">
            <el-select
              v-model="valueGroupName"
              clearable
              :placeholder="$t('createQuotation.editConfigurationGroup')"
              style="width: 220px"
              @change="getGroupName(projectId)"
            >
              <el-option
                v-for="item in groupNames"
                :key="item.groupId"
                :label="item.groupName"
                :value="item.groupId"
              />
            </el-select>

            <el-select
              v-model="valueSubName"
              multiple
              collapse-tags
              style="margin-left: 20px; width: 220px"
              :placeholder="$t('createQuotation.productSeries')"
              @focus="getSubName(valueGroupName)"
            >
              <el-option
                v-for="item in subNames"
                :key="item.subId"
                :label="item.subProductName"
                :value="item.subId"
              />
            </el-select>
            <el-input
              v-model="totalDiscount"
              style="margin-left: 20px; width: 220px"
              :placeholder="$t('createQuotation.pleaseDiscountValue')"
              @keyup.enter.native="adhibitionDiscount"
            />
          </div>
          <div class="grid-content ">
            <el-button
              type="primary"
              @click="adhibitionDiscount"
            >
              {{ $t('createQuotation.application') }}
            </el-button>
            <el-button @click="resetForm()">
              {{ $t('createQuotation.reset') }}
            </el-button>
          </div>
          <span
            class="show-project-cycle-tips"
            v-if="shareMessageDto.deliveryPeriod !=null
              && shareMessageDto.deliveryPeriod !=''"
          >
            {{ $t('homePage.currentProjectCycle') }}
            {{ shareMessageDto.deliveryPeriod }}
            {{ $t('homePage.DaysCRMSystem') }}
          </span>
          <div class="grid-content " style="float: right;">
            <el-button
              type="primary"
              @click="applyItemDiscount"
            >
              {{ $t('createQuotation.totalQuantity') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="table-one">
      <table id="table2">
        <thead style="text-align: left">
          <tr>
            <!--配置组-->
            <th class="configuration-group" style="width:10%; text-align: left">
              {{ $t('createQuotation.configurationSet') }}
            </th>
            <!--width: 20%-->
            <!--产品系列-->
            <th style="min-width: 215px; text-align: left">
              {{ $t('createQuotation.productSeries') }}
            </th>
            <!--产品名称 width: 10%-->
            <th style="min-width:452px;text-align: left">
              {{ $t('createQuotation.productName') }}
            </th>
            <!--产品型号-->
            <th style="min-width: 500px;text-align: left">
              {{ $t('createQuotation.productModel') }}
            </th>
            <!--折扣值（%）-->
            <th style="min-width: 214px;text-align: left">
              {{ $t('createQuotation.theDiscountValue') }}
            </th>
            <!--目录单价（元）-->
            <th style="min-width: 231px;text-align: left">
              {{ $t('createQuotation.directoryPrice') }}
            </th>
            <!--服务商单价（元）-->
            <th style="min-width: 233px;text-align: left">
              {{ $t('createQuotation.serviceUnitPrice') }}
            </th>
            <!--促销单价（元）-->
            <th style="min-width: 215px;text-align: left" v-if="!isPartner">
              {{ $t('createQuotation.salesUnitPrice') }}
            </th>
            <!--折后单价（元）-->
            <th style="min-width: 234px;text-align: left">
              {{ $t('createQuotation.afterFoldingUnitPrice') }}
            </th>
            <!--总数量-->
            <th style="min-width: 90px;text-align: left">
              {{ $t('createQuotation.totalNumber') }}
            </th>
          </tr>
        </thead>
        <tbody v-for="(item,i) in tableData6" :key="i">
          <tr>
            <td style="width: 150px;white-space: normal">{{ item.groupName }}</td>
            <td :colspan="colspan">
              <table class="table2" frame="void">
                <tr v-for="(par, j) in item.groupSubItemDListVOList" :key="j">
                  <td style="min-width: 110px;width:10%;text-align: left;padding-left: 10px">
                    {{ par.productSeriesName }}
                  </td>
                  <td>
                    <table class="table3" frame="void">
                      <template v-for="(row,indexs) in par.productItems">
                        <Row :row="row" :sub-item="par" :is-partner="isPartner" ref="productRow" :key="indexs" />
                      </template>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <!-- :colspan="isPartner?5:4"-->
            <td
              colspan="4"
              style="color:#000000;font-weight: 700;background-color: #eef1f6; padding-left: 10px;text-align: left"
            >
              <!--小计-->
              {{ $t('createQuotation.subtotal') }}
            </td>
            <td style="color: #000000;font-weight: 700">
              {{ discountRatio(item) | number }}
            </td>
            <td style="color: #000000;font-weight: 700">
              {{ productPriceFormat(null,null,subtotalPrice(item)) }}
            </td>
            <td style="color: #000000;font-weight: 700; min-width: 260px; width: 260px">
              {{ productPriceFormat(null,null,subtospdcPrice(item)) }}
            </td>
            <td style="color: #000000;font-weight: 700">
              {{ totalQuantity(item) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="btn-p">
      <el-button @click="lastStepToCreatOrderFirst">
        <!--上一步，配置产品清单-->
        {{ $t('createQuotation.stepConfigurationList') }}
      </el-button>
      <el-button type="primary" @click="toCreatorderfourth">
        <!--下一步，导出&分享-->
        {{ $t('createQuotation.nextStep') }}
      </el-button>
    </div>
    <!--出口合规风险提示弹窗-->
    <ExportComplianceDialog
      :visible.sync="complianceDialog.visible"
      :mode="complianceDialog.mode"
      :level="complianceDialog.level"
      :conclusion="complianceDialog.conclusion"
      :details="complianceDialog.details"
      @cancel="onComplianceCancel"
      @confirm="onComplianceConfirm"
      @submit-review="onComplianceSubmitReview"
    />
  </div>
</template>

<script>
import Row from './Row';
import API from '../../api';
import step from '../../utils/step';
import exportCompliance from '@/utils/exportCompliance';
import { productPriceFormat } from '@/utils/numberFormater';
import { getStore, isPartnerM } from '@/utils/mUtils';
export default {
  mixins: [step, exportCompliance],
  name: 'CreatOrderThird',
  data () {
    return {
      projectId: '',
      projectName: '',
      totalRatioPriceShow: 0,
      num1: 0,
      orderPrice: 0, // 最初的总价
      totalDiscount: '', // 应用input表单接受总折扣率
      tableData6: [],
      groupNames: [],
      subNames: [],
      valueGroupName: '',
      valueSubName: [],
      isPartner: true,
      colspan: 8,
      shareMessageDto: {
        lowerShelf: '',
        spdcProduct: '',
        orderInfo: '',
        supplyInfo: [],
        deliveryPeriod: ''
      },
      // 出口合规检测状态与弹窗数据由 exportCompliance 混入提供
    };
  },
  computed: {
    // 计算属性
    // 单个折扣率发生变化时
    orderDiscountPrice () {
      let cont = 0;
      // 总计和
      this.tableData6.forEach(item => {
        cont += item.totalRatioPrice;
      });
      if (isNaN(cont)) {
        return '';
      }
      return cont;
    },
    // 整单折扣计算
    totalDiscountShow () {
      let cont = 100;
      if (this.orderPrice === 0) {
        return cont;
      }
      try {
        cont = this.orderDiscountPrice / this.orderPrice * 100;
      } catch (e) {
        return 100;
      }
      if (isNaN(cont)) {
        return '';
      }
      return cont;
    }

  },
  components: {
    Row
  },
  mounted () {
    this.getGroupName(this.$route.query.secondProjectId);
    this.isPartner = isPartnerM();
    if (this.isPartner) {
      this.colspan = 9;
    } else {
      this.colspan = 10;
    }
    // 获取url 参数
    this.projectId = this.$route.query.secondProjectId;
    this.projectName = this.$route.query.projectName;
    this.getConfigGroupAndProductItemListByProjectId();
    this.getLowershelf(this.projectId);
  },
  methods: {
    productPriceFormat,
    resetForm () {
      this.valueGroupName = '';
      this.valueSubName = [];
      this.totalDiscount = '';
    },
    // 小计折扣率
    discountRatio (rows) {
      let cont = 0;
      cont = this.subtotalDiscountPrice(rows) / this.subtotalPrice(rows) * 100;
      if (isNaN(cont)) {
        return '';
      }
      return cont;
    },
    // 小计原价
    subtotalPrice (rows) {
      let arrays = [];
      let cont = 0;

      rows.groupSubItemDListVOList.forEach((item) => {
        arrays = item.productItems;
        arrays.forEach((productItem) => {
          cont = cont + productItem.productPrice * productItem.purchaseQuantity * item.tcount;
        });
      });
      rows.totalPrice = cont;
      return cont;
    },
    // 小计服务商价格
    subtospdcPrice (rows) {
      let arrays = [];
      let cont = 0;
      rows.groupSubItemDListVOList.forEach((item) => {
        arrays = item.productItems;
        arrays.forEach((productItem) => {
          // eslint-disable-next-line no-mixed-operators
          if ((productItem.isSpdc === 1) && (!this.isPartner || this.isPartner && getStore('partnerAuth') === '1')) {
            cont = cont + productItem.spdcPrice * productItem.purchaseQuantity * item.tcount;
          }
        });
      });
      if (cont === 0) {
        return null;
      }
      return cont;
    },
    // 目录总价
    orderPriceCalculate () {
      // console.log("计算目录总价=====",this.tableData6);
      let cont = 0;
      let total = 0;
      let tcount = 0;
      this.tableData6.forEach((groupSubItemDListVOListObj) => {
        cont = 0;
        tcount = 0;
        groupSubItemDListVOListObj.groupSubItemDListVOList.forEach((groupSubItemDListVOList) => {
          groupSubItemDListVOList.productItems.forEach((item) => {
            cont = cont + item.productPrice * item.purchaseQuantity * groupSubItemDListVOList.tcount;
            tcount = tcount + item.purchaseQuantity;
          });
          groupSubItemDListVOListObj.totalPrice = cont;
        });
        total = total + groupSubItemDListVOListObj.totalPrice;
      });
      this.orderPrice = total;
      this.tableData6.totalPrice = total;
    },
    // 计算折扣后的小计
    subtotalDiscountPrice (rows) {
      // console.log(rows);
      let arrays = [];
      let cont = 0;

      rows.groupSubItemDListVOList.forEach((groupSubItemDListVOList) => {
        groupSubItemDListVOList.productItems.forEach((item) => {
          cont = cont + item.purchaseQuantity * groupSubItemDListVOList.tcount * item.discountPrice;
          // console.log('subId = ', item.subId)
          // console.log('count = ', cont)
        });
      });
      if (!rows.totalRatioPrice) {
        this.$set(rows, 'totalRatioPrice', cont);
      } else {
        rows.totalRatioPrice = cont;
      }

      return cont;
    },
    // 计算折数量小计
    totalQuantity (rows) {
      let cont = 0;
      rows.groupSubItemDListVOList.forEach((groupSubItemDListVOList) => {
        groupSubItemDListVOList.productItems.forEach((item) => {
          cont = cont + item.purchaseQuantity * groupSubItemDListVOList.tcount;
        });
      });
      return cont;
    },
    validateNum () {
      let reg = /^\d+(\.\d{1,2})?$/;
      return reg.test(this.totalDiscount);
    },
    // 应用折扣率
    adhibitionDiscount () {
      if (this.totalDiscount == null || this.totalDiscount === '') {
        this.totalDiscount = 0;
      } else if (!this.validateNum()) {
        this.$alert(`${this.$t('createQuotation.discountOnlyNumbers')}`, `${this.$t('createQuotation.prompt')}`, {
          confirmButtonText: `${this.$t('createQuotation.confirm')}`
        });
        return false;
      } else if (this.totalDiscount > 100) {
        this.$alert(`${this.$t('createQuotation.discountCannotHigher')}`, `${this.$t('createQuotation.prompt')}`, {
          confirmButtonText: `${this.$t('createQuotation.confirm')}`
        });
        return false;
      } else if (this.totalDiscount < 0) {
        this.$alert(`${this.$t('createQuotation.discountCannotNegative')}`, `${this.$t('createQuotation.prompt')}`, {
          confirmButtonText: `${this.$t('createQuotation.confirm')}`
        });
        return false;
      }
      this.applyAllDiscount();
    },
    getConfigGroupAndProductItemListByProjectId () {
      API.getConfigGroupAndProductItemListByProjectId({ params: {
        projectId: this.projectId
      } }).then((res) => {
        let json = res.data;
        // console.log(json);
        if (json.status === '200') {
          this.tableData6 = json.data;
          this.orderPriceCalculate();
          this.totalDiscountShow();
        } else {
          // 添加失败
          this.$message.error(json.data);
        }
      }).catch(()=>{});
    },
    applyAllDiscount () {
      let body = {
        projectId: this.projectId,
        totalDiscount: this.totalDiscount,
        valueGroupName: this.valueGroupName,
        valueSubName: this.valueSubName
      };
      API.applyAllDiscount(
        body
      ).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.getConfigGroupAndProductItemListByProjectId();
          this.messageHints(`${this.$t('createQuotation.discountSuccessfully')}`, 'success');
        }
      }).catch(() => {
        this.messageHints(`${this.$t('createQuotation.discountCalculatedFailure')}`, 'error');
      });
    },

    applyItemDiscount () {
      let body = {
        projectId: this.projectId,
        configGroupDataVOList: this.tableData6
      };
      return API.applyItemDiscount(body).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.messageHints(`${this.$t('createQuotation.discountSuccessfully')}`, 'success');
          return true;
        }
        this.messageHints(`${this.$t('createQuotation.discountCalculationSaveFailed')}`, 'error');
        return false;
      }).catch(() => {
        this.messageHints(`${this.$t('createQuotation.discountCalculationSaveFailed')}`, 'error');
        return false;
      });
    },
    lastStepToCreatOrderFirst () {
      // 上一步
      this.$router.push({ name: 'CreatOrderSecond', query: { projectId: this.projectId, projectName: this.projectName } });
    },
    toCreatorderfourth () {
      // 先做出口合规检测，通过后再保存折扣并进入第四步
      this.runExportCompliance(this.projectId, () => this.saveDiscountAndJump());
    },

    // 保存折扣后进入第四步（合规通过 / 2级确认 / 异常人工放行时调用）
    saveDiscountAndJump () {
      this.complianceChecking = true;
      this.applyItemDiscount().then((success) => {
        this.complianceChecking = false;
        if (success) {
          this.jumpToFourth();
        }
      });
    },

    jumpToFourth () {
      this.$router.push({ name: 'CreatOrderFourth', query: { projectId: this.projectId, projectName: this.projectName } });
    },

    messageHints (title, type) {
      this.$notify({
        title: title,
        type: type
      });
    },
    getLowershelf (projectId) {
      API.getLowershelf({ params: { 'projectId': projectId } }).then((res) => {
        let json = res.data;
        this.shareMessageDto = json.data;
      }).catch(err => {
        console.log(err);
      });
    },
    getGroupName (projectId) {
      this.valueSubName = [];
      API.getGroupName({ params: { projectId: projectId } }).then((res) => {
        let json = res.data;
        this.groupNames = json.data;
        //console.log(this.groupNames);
      });
    },
    getSubName (groupId) {
      API.getSubName({ params: { groupId: groupId } }).then((res) => {
        let json = res.data;
        this.subNames = json.data;
        // console.log(this.subNames);
        // console.log(groupId);
      });
    }

  },
  filters: {
    number (value) {
      return Number(value).toFixed(2);
    }
  }
};
</script>
<style lang="scss">
  @import "../../styles/product-common.css";
  .t-r {
    text-align: right;
  }
  .order-third {
    .show-project-cycle-tips{
      color: red;
      /* word-break: break-word; */
      display: inline-block;
      width: 25%;
      display: -webkit-box;
      float: left;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .el-step__icon.is-icon{
      width: 6rem !important;
    }
    .el-button{
      height: 3rem !important;
      line-height: 0;
    }
  }

  .order-third .flow-chart {
    max-width:1200px;
    min-width: 1024px;
    margin: 2rem auto 0;
  }

  .flow-chart img {
    width: 80%;
    text-align: center;
  }

  .order-form {
    margin-top: 9rem;
  }

  .demo-input-suffix input {
    height: 2.2rem;
  }

  .demo-input-suffix .grid-content {
    line-height: 2.2rem;
  }

  textarea:focus {
    border-color: #36BAE2 !important;
  }

  .btn-p {
    margin-top: 8rem;
  }

  .order-third .select-option {
    margin-top: 1rem;
    margin-bottom: 12px;
    text-align: left;
  }

  .order-third  .select-option .f-blue {
    font-weight: 700;
    color: #fe7500;
  }

  .order-third .discount {
    text-align: left;
    height: 2.2rem;
    line-height: 2.2rem;
  }

  .order-third .btn-p {
    margin-top: 4rem;
  }

  .order-third .table-one {
    margin-top: 3rem;
    width: 100%;
    overflow-x: scroll;
  }

  .order-third .table-one table tr {
    height: 2.6rem;
  }

  .order-third .table-one table tr td {
    color: #666666;
  }

  .order-third .table-one table tr td,
  .order-third .table-one table tr th {
    border: solid 1px #EBEBEB;
  }

  .order-third .table-one table + table,
  .order-third .table-one table + table tr:nth-of-type(1),
  .order-third .table-one table + table tr:nth-of-type(1) th {
    border-top: none;
  }

  .order-third .table-one table tr td {
    color: #666666;
  }

  .table2 * {
    margin: 0;
    padding: 0;
  }

  .table2 .product-dgxx table th, td {
    padding: 0;
  }

  .order-third .table-one table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
  }

  .order-third .table-one #table2 {
    min-width: 1200px;
    thead,th{
      height: 2.6rem !important;
      padding: 8px 10px;
      background-color:#eef1f6 !important;
    }
  }

  .order-third .grid-content{
    float: left;
    margin-right: 2rem;
    height: 3.2rem;
    line-height: 3.2rem;
  }

  .clear{
    clear: both;
  }

  @media screen and (max-width: 1440px) {
    .order-third .configuration-group{
      width: 150px;
    }
  }

  @media screen and (max-width: 1366px) {
    .order-third .select-option {
      margin-top: 2rem;
    }
    .order-third .table-one{
      margin-top: 1rem;
    }

    .order-third .btn-p{
      margin-top: 4rem;
    }

    .order-third .discount .el-row{
      height: 3rem;
      line-height:3rem;
    }

    .order-third .discount .el-col{
      height: 3rem;
      line-height:3rem;
    }

    .order-third .discount{
      margin-top: 1rem;
    }

  }
</style>
